<template>
  <div class="fixed z-10 inset-0 overflow-y-auto">
    <div class="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">

      <div class="fixed inset-0 transition-opacity" aria-hidden="true">
        <div class="absolute inset-0 bg-gray-500 opacity-75"></div>
      </div>

      <span class="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">&#8203;</span>
      <div
          class="inline-block align-bottom bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full sm:p-6"
          role="dialog" aria-modal="true" aria-labelledby="modal-headline">
        <div class="hidden sm:block absolute top-0 right-0 pt-4 pr-4">
          <button type="button" @click="closeModal"
                  class="bg-white rounded-md text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-tlmblue2">
            <span class="sr-only">Close</span>
            <svg class="h-6 w-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                 stroke="currentColor" aria-hidden="true">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/>
            </svg>
          </button>
        </div>
        <form method="POST" action="/therapist-pages/post_registration">
          <input type="hidden" name="_token" :value="csrfToken">
          <input type="hidden" name="date" :value="this.date">
          <template v-if="portalTherapistId">
            <input type="hidden" :value="portalTherapistId" name="portal_therapist_id">
          </template>
          <div class="sm:flex sm:items-start">
            <div v-if="!hasSchedules"
                 class="mx-auto flex-shrink-0 flex items-center justify-center h-12 w-12 rounded-full bg-red-100 sm:mx-0 sm:h-10 sm:w-10">
              <svg class="h-6 w-6 text-red-600" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                   stroke="currentColor" aria-hidden="true">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                      d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"/>
              </svg>
            </div>

            <div class="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">
              <h3 class="text-lg leading-6 font-medium text-gray-900" id="modal-headline">
                {{ transEdit('post-registration') + ' ' + getDate(date) }}
              </h3>
              <div class="mt-2">
                <p class="text-sm text-gray-500">
                  {{ transEdit('post-registration-info') }}
                </p>
                <div v-if="hasSchedules">
                  <hr>
                  <div class="mt-4 space-y-4">
                    <div v-for="(schedule, index) in schedules" class="relative flex items-center mb-4">
                      <div class="flex items-center h-5">
                        <input id="comments" type="checkbox"
                               :name="'booked['+schedule.id+']'"
                               @change="updateNameValue($event, index)"
                               class="focus:ring-tlmblue2 h-4 w-4 text-tlmblue2 border-gray-300 rounded">
                        <div class="ml-3 text-sm">
                          <label for="comments" class="font-medium text-gray-700">{{ getTime(schedule.start) }} -
                            {{ getTime(schedule.end) }}</label>
                        </div>
                      </div>

                      <div class="flex-grow ml-8">
                        <div class="sm:col-span-4">
                          <div class="mt-1">
                            <input :name="'booked_name['+schedule.id+']'"
                                   :placeholder="transEdit('name')"
                                   v-model="schedule.name"
                                   type="text"
                                   class="shadow-sm focus:ring-tlmblue2 focus:border-tlmblue2 block w-full sm:text-sm border-gray-300 rounded-md">
                          </div>
                        </div>
                        <div class="sm:col-span-3">
                          <div class="mt-1">
                            <select :name="'booked_treatment['+schedule.id+']'"
                                    class="shadow-sm focus:ring-tlmblue2 focus:border-tlmblue2 block w-full sm:text-sm border-gray-300 rounded-md">
                              <option v-for="treatment in treatments" :value="treatment.id">{{
                                  treatment.name
                                }}
                              </option>
                            </select>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <hr>
                  <div class="sm:col-span-6 mt-4">
                    <label for="about" class="block text-sm font-medium text-gray-700">
                      {{ transEdit('comment') }}
                    </label>
                    <div class="mt-1">
                      <textarea id="about"
                                rows="3"
                                name="report"
                                class="shadow-sm focus:ring-tlmblue2 focus:border-tlmblue2 block w-full sm:text-sm border-gray-300 rounded-md"
                                ></textarea>
                    </div>
                  </div>
                </div>
                <div v-else>
                  <hr class="my-2">
                  {{ transEdit('post-registration-no-schedules') }}
                </div>
              </div>
            </div>
          </div>

          <div class="mt-5 sm:mt-4 sm:flex sm:flex-row-reverse">
            <button v-if="hasSchedules" type="submit"
                    class="btn-primary mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 text-base font-medium text-gray-700 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-tlmblue sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm">
              {{ transEdit('post-register') }}
            </button>
            <button type="button" @click="closeModal"
                    class="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-red-600 text-base font-medium text-white hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 sm:mt-0 sm:w-auto sm:text-sm">
              {{ transEdit('cancel') }}
            </button>

          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
export default {
  name: "TherapistDashPostRegistrationModal",
  props: ['date'],
  data() {
    return {
      schedules: [],
      treatments: [],
      schedulesToBook: [],
      names: [],
    };
  },
  computed: {
    portalTherapistId() {
      return window.Laravel.portal_therapist_id ? window.Laravel.portal_therapist_id : null;
    },
    hasSchedules() {
      return this.schedules.length > 0;
    },
    csrfToken() {
      return window.Laravel.csrfToken;
    }
  },
  methods: {
    getDate(dateString) {
      return moment(dateString).format('YYYY-MM-DD');
    },
    getDateTime(dateString) {
      return moment(dateString).format('YYYY-MM-DD') + ' kl. ' + moment(dateString).format('HH:mm')
    },
    getTime(dateString) {
      return moment(dateString).format('HH:mm')
    },
    updateNameValue(e, index) {
      let str = e.target.checked ? 'Bokad kund' : '';
      this.$set(this.schedules[index], 'name', str);
    },
    getPostRegistrationSchedules() {
      let self = this;
      axios.get(this.$portalUrl('/therapist-pages/post_registration'), {
        params: {
          'date': this.getDate(this.date),
        }
      }).then((res) => {
        if (res.data) {
          self.schedules = res.data.schedules;
          self.treatments = res.data.treatments;
          for (let i = 0; i < self.schedules.length; i++) {
            this.$set(self.schedules[i], 'name', '');
          }
        } else {
          Vue.toasted.error(res.data[1])
        }
      });
    },
    submitPostRegistration() {
      axios.post(this.$portalUrl('/therapist-pages/post_registration'), {
        'date': this.date,
        'portal_therapist_id': window.Laravel.portal_therapist_id,
      }).then((res) => {
        if (res.data[0]) {
          Vue.toasted.success(res.data[1]);
          this.$emit('close');
        } else {
          Vue.toasted.error(res.data[1]);
        }
      });
    },
    closeModal() {
      this.$emit('close');
    }
  },
  mounted() {
    this.getPostRegistrationSchedules();
  }
}
</script>

<style scoped>
.btn-primary {
  color: #fff;
  background-color: #007bff;
  border-color: #007bff;
}
</style>
